angular.module('picmonicng').factory('TypeformModal', [
  '$modal',
  function ($modal) {
    return {
      show: function (typeformId, modalIcon, modalTitle) {
        $modal.open({
          templateUrl: '/templates/app/factories/typeform-modal/typeform-modal.html',
          windowClass: 'typeform-modal full-screen-modal',
          backdrop: 'static',
          size: 'lg',
          controller: [
            '$scope',
            '$sce',
            function ($scope, $sce) {
              $scope.typeformId = typeformId;
              $scope.modalIcon = modalIcon;
              $scope.modalTitle = modalTitle;

              $scope.getIframeSrc = function () {
                return $sce.trustAsResourceUrl('/typeform/' + typeformId);
              };
            },
          ],
        });
      },
    };
  },
]);
